export const SET_ALL_SERVERS = 'logs/SET_ALL_SERVERS';
export const SET_CURRENT_SERVER = 'logs/SET_SERVER';
export const SET_LOG = 'logs/SET_LOG';
export const CLEAR_LOGS = 'logs/CLEAR_LOGS';
export const SET_STATUS = 'logs/SET_STATUS';
export const TOGGLE_SHOW_IN_BROWSER_CONSOLE = 'logs/TOGGLE_SHOW_IN_BROWSER_CONSOLE';
export const PAUSE_LOGS = 'logs/PAUSE_LOGS';
export const RESUME_LOGS = 'logs/RESUME_LOGS';
